/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolVillaIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-villa"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.68 21.32L8.68 14.32Q8.68 13.2 9.44 12.44Q10.2 11.68 11.32 11.68L16.32 11.68Q16.32 10.63 17.05 9.9Q17.77 9.18 18.82 9.18Q19.88 9.18 20.6 9.9Q21.32 10.63 21.32 11.68L21.32 21.32L16.32 21.32L16.32 17.35Q16.32 16.8 15.94 16.41Q15.55 16.02 15 16.02Q14.45 16.02 14.06 16.41Q13.68 16.8 13.68 17.35L13.68 21.32ZM2.67 21.32L2.67 9.6Q2.67 8.78 3.14 8.1Q3.6 7.42 4.38 7.13L14.53 3.23Q15.18 2.98 15.75 3.36Q16.32 3.75 16.32 4.45L16.32 9.68L10.65 9.68Q9 9.68 7.84 10.84Q6.67 12 6.67 13.65L6.67 21.32Z" fill={color} />
    </svg>
  );
}
